export { default } from "./Tipografia";
